import { call, put } from 'redux-saga/effects';
import api from '../../services/api';

import { Creators as CampaignsCreators } from '../ducks/campaigns';

export function* getCampaign({ payload }) {
  const response = yield call(api.get, 'v2/campaigns/default', { id: payload.id });

  if (response.ok) {
    yield put(CampaignsCreators.setCampaign(response.data));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/campaigns.js